import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { DocumentsPage } from '@/features/documents/pages/DocumentsPage'

const searchSchema = z.object({
  tab: z.enum(['invoice', 'quotation', 'proforma', 'credit_note', 'debit_note']).catch('invoice'),
})

export const Route = createFileRoute('/_app/documents/')({
  validateSearch: searchSchema,
  component: DocumentsPage,
})
